import * as R from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { compose } from 'recompose';
import GeographyGrid from 'components/general/GeographyGrid/GeographyGrid';
import GeographyGridSkeleton from 'components/general/GeographyGrid/GeographyGridSkeleton';
import { selectors } from './../ducks/list.duck';
import withLoadingError from '../../../components/hoc/withLoadingError';

const getItems = createSelector(
  selectors.inOrder,
  R.map(R.applySpec({
    title: R.prop('title'),
    iso: R.prop('iso'),
    slug: R.prop('slug'),
  })),
);

const CountryList = compose(
  connect(R.applySpec({
    items: getItems,
    loading: selectors.loading,
  })),
  withLoadingError({
    renderLoading: () => <GeographyGridSkeleton />,
  }),
)(GeographyGrid);

export default CountryList;
